import { API } from 'aws-amplify';
import axios from 'axios';

import { getLocalHeaders } from '../api/makeAjaxRequest';
import config from './aws';

export class ApiCallDispatcher {
    config = [];

    configure(conf) {
        this.config = conf;
    }

    async post(api, path, data) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            const response = await axios.post(endpointConf.endpoint + path, data, {
                headers: await getLocalHeaders(),
            });
            return response.data;
        } else {
            return API.post(api, path, {
                body: data,
            });
        }
    }

    async get(api, path, args = '') {
        const endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        const isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        const fullPath = args ? `${path}?${args}` : path;
        if (isLocal) {
            const response = await axios.get(endpointConf.endpoint + fullPath, {
                headers: await getLocalHeaders(),
            });
            return response.data;
        } else {
            return API.get(api, fullPath, {});
        }
    }

    async put(api, path, data) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            const response = await axios.put(endpointConf.endpoint + path, data, {
                headers: await getLocalHeaders(),
            });
            return response.data;
        } else {
            return API.put(api, path, {
                body: data,
            });
        }
    }

    async del(api, path) {
        let endpointConf = this.config.apiGatewayEndpoints.find((a) => a.name === api);
        let isLocal = endpointConf.endpoint.includes('localhost') || endpointConf.endpoint.includes('127.0.0.1');

        if (isLocal) {
            const response = await axios.delete(endpointConf.endpoint + path, {
                headers: await getLocalHeaders(),
            });
            return response.data;
        } else {
            return API.del(api, path, {});
        }
    }
}

const ApiDispatcher = () => {
    const conf = config;
    const dispatcher = new ApiCallDispatcher();
    dispatcher.configure(conf);
    return dispatcher;
};
export const Api = ApiDispatcher();
